import { useQuery } from '@tanstack/react-query';
import * as AdminModels from '../../../models/AdminModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { AdminUserSessionContext } from '../../../viewmodels/AdminViewModels';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'admin/AutomationTemplate/{id}';

export function useIndustryAutomationTemplateQuery({ enabled = true, id }: { enabled?: boolean; id: string }) {
	const userSession = useUserSession<AdminUserSessionContext>();
	return useQuery({
		enabled: enabled && !!id,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<AdminModels.ISystemAutomationTemplate>(
				`admin/AutomationTemplate/${id}`,
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, id],
	});
}

export const invalidateIndustryAutomationTemplateQuery = (id: string) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, id] });
};
